export default "__VITE_ASSET__CEKWiNr___"